import {Component, OnInit} from '@angular/core';
import {IstanzaService} from "../../services/istanza.service";
import {ActivatedRoute, Router} from "@angular/router";
import {Istanza, IstanzaDTO} from "../../models/istanza";
import {UserData} from "../../models/user-data";
import {AccountService} from "../../core/auth/account.service";
import {SubscriptionManager} from "../../shared/subscription-manager/subscription-manager.class";
import {DynamicFormRenderService} from "dmidynamic-form-render";
import {zonedTimeToUtc} from "date-fns-tz";
import {format, parse} from "date-fns";
import {LangChangeEvent, TranslateService} from "@ngx-translate/core";
import {AlertService} from "../../shared/alert/alert.service";
import {TributiService} from "../../services/tributi.service";
import {MessageService} from "../../services/message.service";
import { ConfigurazioneGeneraleService } from '../../services/configurazione-generale.service';

@Component({
  selector: 'jhi-dettaglio-istanza',
  templateUrl: './dettaglio-istanza.component.html',
  styleUrls: ['./dettaglio-istanza.component.scss']
})
export class DettaglioIstanzaComponent extends SubscriptionManager implements OnInit {
  id: string;
  istanzaCorrente?: IstanzaDTO;
  loading: boolean;
  visualizzaJson = false;
  mapStatiPagamento: Map<string, {testo: string, colore: string}>;
  mapRuoli: Map<string, string>;
  selectedLanguage: string = this.translateService.currentLang;
  mapEstensioni: Map<string, string>;
  showTooltip = false;


  constructor(private tributiService: TributiService, private configurazioneGeneraleService: ConfigurazioneGeneraleService,private messageService: MessageService, private alertService: AlertService, private istanzaService: IstanzaService, private translateService: TranslateService, private dynamicFormRenderService: DynamicFormRenderService, private activatedRoute: ActivatedRoute, private accountService: AccountService, private router: Router) {
    super();
    this.id = this.activatedRoute.snapshot.params.idIstanza;
    this.loading = false;
    this.mapStatiPagamento = new Map([
      ["00", {testo: "Da pagare", colore: "red"}],
      ["01", {testo: "Pagato", colore: "green"}],
      ["10", {testo: "Annullato", colore: "orange"}]
    ])
    this.mapEstensioni = new Map(
      [
        ["pdf", "application/pdf"],
        ["zip", "application/x-zip-compressed"],
        ["xls", "application/vnd.ms-excel"],
        ["jpg", "image/jpeg"],
        ["png", "image/png"],
        ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
        ["PDF", "application/pdf"],
        ["ZIP", "application/x-zip-compressed"],
        ["XLS", "application/vnd.ms-excel"],
        ["JPG", "image/jpeg"],
        ["PNG", "image/png"],
        ["DOCX", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"]
      ]
    );
    this.mapRuoli = new Map([
      ["ROLE_USER", 'Utente'],
      ['ROLE_EMPLOYEE', 'Operatore']
    ])
  }

  ngOnInit(): void {
    this.loading = true;
    this.subs.sink = this.istanzaService.getDatiIstanza(this.id).subscribe({
      next: (res) => {
        this.loading = false;
        this.istanzaCorrente = res;
        this.dynamicFormRenderService.importaFormDinamico(JSON.parse(this.b64DecodeUnicode(<string>this.istanzaCorrente?.istanza.servizio.jsonForm?.contenuto)))
        this.dynamicFormRenderService.importaValori(JSON.parse(this.b64DecodeUnicode(<string>this.istanzaCorrente?.jsonData?.contenuto)))
        this.dynamicFormRenderService.disabilitaFormDinamico();
      },
      error: () => {
        void this.router.navigate(['error']);
      },
      complete: () => {
        this.loading = false;
      },
    })
    this.subs.sink = this.translateService.onLangChange.subscribe((langChangeEvent: LangChangeEvent) => {
      this.selectedLanguage = langChangeEvent.lang
    });
  }

  checkTooltip(): boolean {

    this.showTooltip = this.istanzaCorrente?.istanza.stato.codice === '06';
    return this.showTooltip;
  }

  hideTooltip(): boolean{
    this.showTooltip = false;
    return this.showTooltip;
  }

  downloadIntegrazione(base64String: string | null, fileName: string): void {
    const split = fileName.split('.');
    const fileExtension = split[split.length - 1];
    const fileExtensionMapped = this.mapEstensioni.get(fileExtension)
    const source = 'data:' + fileExtensionMapped + `;base64,${<string>base64String}`;
    const link = document.createElement('a');
    link.href = source;
    link.download = `${fileName}`;
    link.click();
  }

  backToIstanzeEmesse():void{
    void this.router.navigate(['Servizi/IstanzeEmesse'])
  }

  b64DecodeUnicode(str: string): string {
    return decodeURIComponent(window.atob(str).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
  }

  visualizzaJsonForm():void{
    this.visualizzaJson = true;
  }

  nascondiJsonForm():void{
    this.visualizzaJson = false;
  }

  formatDate(date: string | undefined): Date {
    return zonedTimeToUtc(parse(date ? date : '', "yyyy-MM-dd", new Date()), 'Europe/Rome');
  }

  format(data: Date | undefined): string {
    return format(parse(data!.toString(), "yyyy-MM-dd", new Date()), 'dd/MM/yyyy');
  }

  formatDateTs(date: Date): Date {
    return zonedTimeToUtc(date, 'Europe/Rome');
  }

  formatDateNormal(date: Date): string {
    return format(new Date(date), 'dd/MM/yyyy');
  }

  getIntegrazione(id: string | null | undefined): void {
    void this.router.navigate(['Servizi/integrazioneIstanza/' + <string>id], {state: {previousRoute: "/Servizi/DettaglioIstanza/" + <string>id}});
  }

  goToIstanzeEmesse():void{
    return void this.router.navigate(['Servizi/IstanzeEmesse']);
  }

  goToHome():void{
    window.location.href = this.configurazioneGeneraleService.configurazione.linkHome;
  }

  goToPagamento(istanza: Istanza,idpagamento: number): void {
    this.loading = true;
    this.subs.sink = this.tributiService.getIntegrazione(<string>istanza.id).subscribe({
      next: (res) => {
        const pagamentoSelezionato = res.pagamento.find((x: { id: number; })  =>  x.id === idpagamento);
        this.messageService.sendPagamento({
          integrazione: res.integrazione,
          pagamento: pagamentoSelezionato,
          descrizione: <string>istanza.descrizione,
          cdServizio: istanza.servizio.cdServizio ? istanza.servizio.cdServizio : '',
          flPagamento: <boolean>istanza.servizio.flPagamento
        })
        void this.router.navigate(['Servizi/PagamentoIstanza'], {state: {previousRoute: "Servizi/IstanzeEmesse"}})
      },
      error: (err) => {
        this.loading = false;
        this.alertService.creaAlert(err.error.messaggio, "danger", "sticky", 3000, true)
      },
      complete: () => {
        this.loading = false;
      }
    })
  }

  scaricaAvviso(avvisoPagopa: string | null): void {
    if (avvisoPagopa != null) {
      const byteCharacters = atob(avvisoPagopa);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], {type: 'application/pdf'});

      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = 'avvisoPagoPa.pdf';
      link.click();

      URL.revokeObjectURL(url);
    }
  }

}
